


























































































































































































































































































































































































































































































/**
 * 后台负责人：陈孟涛
 * 后台负责人：周鹏（交易明细）
 */
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { money } from "@root/lib/formRules.ts";
import { phoneRegexp, idCardRegexp } from "@root/lib/regexps.ts";
import { getNowYYYYMMDDhhmmss } from "@root/lib/utils.ts";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore
} from "@root/lib/decorator";
import NP from "number-precision";
import { moneyRegexp } from "@root/lib/regexps";
import debounce from "lodash.debounce";
import CustomExportButton from "@/components/custom/CustomExportButton.vue";

const paySet = namespace("paySet");
const bonus = namespace("bonus");
const root = namespace("root");

@Component({
  components: { CustomExportButton },
  data() {
    return {
      numMoney: money,
      phoneRegexp,
      idCardRegexp
    };
  },
  filters: {
    dNull(val) {
      return val || "-";
    },
    formatMoney(money) {
      if (money && money !== null) {
        // return money.replace(/\d(?=(\d{3})+.)/g, "$&,");
        return money.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    }
  }
})
@SearchbarControl()
@loading()
@IsMore()
export default class VirtualAccount extends Vue {
  @root.State ddCodes;

  @paySet.State VIRTUAL_ACCOUNT_STATUS;
  @paySet.State PLATFORM_USERCODE;
  @paySet.State ACCOUNT_TYPE;
  @paySet.State CURRENCY;
  @paySet.State CHANNELTYPE;
  @paySet.State PAYMENT_TYPE;
  @paySet.State CONFIRM_RIGHT_STATUS;

  @paySet.State corporateNoTypeOptions;
  @paySet.State profitabilityOptions; // 企业类型
  @paySet.State merchantTypeMap;
  @paySet.State companyNoTypeOptions; // 公司号类型

  @paySet.Action getLocalFrozenAmt; // 获取子账户信息-待入账资金
  @paySet.Action querySonAccountInfo; // 获取子账户信息
  @paySet.Action cmbOpenSonAccount; // 申请账户
  @paySet.Action cmbOpenAccount; // 申请相关账户
  @paySet.Action withdrawApply;
  @paySet.Action queryWithdrawFlow; // 流水明细
  @paySet.Action queryWtOrderFlowPage; // 交易明细
  @paySet.Action exportWtOrderFlow; // 交易流水

  @bonus.Action getMyBonusAccount;

  private form = {
    platformNo: "", // 平台号
    memberNo: "", // 平台子商户号 == 编码 == userInfo里的member
    memberName: "", // 平台子商户名 == 名称
    bankNo: "", // 平台子商户绑定的银行卡联行号 == 提现银行卡号
    cardName: "", // 平台子商户绑定的银行卡户名
    cardNo: "", // 平台绑定的结算卡号
    accountStatus: null, // 平台状态 1：正常 2：冻结 == 虚拟账户
    frozenAmt: 0, // 平台子商户冻结金额（单位为元） == 冻结资金
    totalAmt: 0, // 资金汇总金额 == 总金额
    availableAmt: 0, // 平台子商户可用金额（单位为元）== 可用资金
    cardType: "", // 结算卡类型 1：招行卡 2：他行卡
    identityType: "", // 平台子商户身份类型 1：自然人 2：企业
    phoneNo: "", // 平台商户管理员的手机号 == 手机号
    widthdrawMoney: null,
    channelStatus: "", // 审核状态
    channelErrorReason: "" // 审核失败原因
  };
  private dialogForm = {
    merchantType: "C", // String! 商户类型：C企业；P自然人
    managerPhone: "", // String! 管理员电话，必须为手机号码
    companyType: "YL", // String! YL营利性组织；NP非营利性组织
    companyNoType: "", // String! 10为企业注册号；20为统一社会信用代码
    companyNo: "", // String! 统一社会信用代码或企业注册号
    companyName: "", // String! 企业名称
    corporateNoType: "1", // String! 有效证件类型：法人证件类型，1-身份证，2-军官证，3-护照，4-户口簿，5-士兵证，6-港澳来往内地通行证，7-台湾同胞来往内地通行证，8-临时身份证，9-外国人居留证，10-警官证，11-其他
    corporateNo: "", // String! 法人（自然人）有效证件号码
    corporatePhone: "", // String! 法人的手机号（企业）或自然人的手机号（自然人）
    corporateName: "", // String! 法人的姓名（企业）或自然人的姓名（自然人）
    remark: "", // String 用于平台向结算通传递一些额外信息，不会向用户展示
    userCode: "", // String! 用户代码
    accountType: "" // String! 账户类型
    // orgCode: ""
  };
  private bonusAmount = 0;

  private flowDataList = [];
  private tradeDataList = [];

  private isSaveLoading = false;
  private tableLoading = false;
  private isApplyLoading = false;
  private loading = false;
  private showConfirmSubmit = false;
  private showApplySubmit = false;
  private isActiveAccount = false;
  private goApplyPageUrl = null;
  private searchFormParams = null;

  private tabOptionsList = [
    { value: "0", label: "交易流水" },
    { value: "1", label: "提现流水" }
  ];
  private activeName = "0";

  private searchForm = {
    serialNumber: "",
    date: []
  };

  // pageInfo
  private total = 0;
  private pageSize = 10;
  private currentPage = 1;
  private layout = "total, prev, pager, next";

  @Watch("showApplySubmit") onDialog(val) {
    this.resetDialogForm();
  }
  isOaCooperation: any = "";
  async created() {
    this.isOaCooperation = localStorage.getItem("isOaCooperation");
    this.$dd.register(["CAPITAL_STATUS", "WT_WITHDRAW_STATUS"]).query();
    await this.getData();
    await this.getMyBonusAccountApi();
    if (!this.isActiveAccount) return;
  }
  async mounted() {
    setTimeout(async () => {
      await this.getDataList();
    }, 1000);
  }
  get userInfo() {
    // 注意： k-one在这里请求时的userCode是本地的orgCode
    return JSON.parse(localStorage.getItem("userInfo") || null);
  }

  get virtualAccountStatus() {
    const { getObjVal } = this;
    return getObjVal("accountStatus")
      ? this.VIRTUAL_ACCOUNT_STATUS[getObjVal("accountStatus")]
      : "未申请";
  }
  get accountCheckStatusStr() {
    const { getObjVal } = this;
    return getObjVal("channelStatusDesc");
  }

  @loadingCatch
  async getData(isLoading?: Boolean) {
    try {
      if (!isLoading) {
        this.loading = false;
      }
      const { orgCode } = this.userInfo;
      let { list: frozenAmtObj } = await this.getLocalFrozenAmt();
      let responseObj = await this.querySonAccountInfo({
        userCode: orgCode
      });
      console.log(responseObj, "00responseObj");
      if (responseObj) {
        responseObj.frozenAmt = frozenAmtObj.amt || "0.00";
        responseObj.totalAmt = (
          Number(responseObj.frozenAmt) + Number(responseObj.availableAmt)
        ).toFixed(2);
      }
      /**
       * 0：审核失败
       * 1：审核中
       * 2：审核成功
       */
      if (responseObj && responseObj["channelStatusCode"]) {
        // 读取状态
        const { channelStatusCode } = responseObj;
        if (String(channelStatusCode) === "2") {
          this.isActiveAccount = true;
        } else {
          // 没有被激活，注意，审核中不能再申请
          this.isActiveAccount = false;
        }
        this.form = responseObj;
      } else if (responseObj && responseObj["accountStatus"] === "1") {
        // 正常使用了
        this.isActiveAccount = true;
        this.form = responseObj;
      } else {
        // 抛出异常
        this.isActiveAccount = false;
      }
      // 获取链接
      const codeUrl = localStorage.getItem("VIRTUAL_PAGE_URL");
      this.goApplyPageUrl = codeUrl;
    } catch (error) {
      console.log(error);
      this.isActiveAccount = false;
    }
  }
  async getMyBonusAccountApi() {
    try {
      const {
        list: { accountOuterSubsetList = [], accountAmount }
      } = await this.getMyBonusAccount();
      const typeLabel = status => {
        const obj = accountOuterSubsetList.find(
          item => parseInt(item && item.fundType) == status
        );
        return (obj && obj.accountAmount) || 0;
      };
      // 可使用金额
      const canUseMoneyStr = typeLabel(2);
      // 待审核金额
      const lockMoneyStr = typeLabel(3);
      // 奖励金余额
      const totalMoneyStr = NP.plus(canUseMoneyStr, lockMoneyStr).toFixed(2);
      this.bonusAmount = totalMoneyStr as any;
    } catch (error) {
      console.log(error);
    }
  }
  applyAccount = debounce(() => {
    this.onApplyAccount();
  }, 500);
  async onApplyAccount() {
    const resetLoading = () => {
      this.isApplyLoading = false;
      this.loading = false;
    };
    try {
      (this.$refs.dialogFormRef as any).validate(async val => {
        if (val) {
          this.isApplyLoading = true;
          const { orgCode } = this.userInfo;
          const { ACCOUNT_TYPE, PLATFORM_USERCODE } = this;
          let input = this.dialogForm;
          input["accountType"] = ACCOUNT_TYPE;
          input["userCode"] = orgCode;
          this.loading = true;
          try {
            const {
              data: {
                data: { code }
              }
            } = await this.cmbOpenAccount({
              input
            });

            const hasRegisterCode = code && code.indexOf("register") > -1;
            if (hasRegisterCode) {
              this.showApplySubmit = false;
              this.getData();
              this.resetDialogForm();
              this.isApplyLoading = false;

              // 跳转页面进行招行的审核
              localStorage.setItem("VIRTUAL_PAGE_URL", code || "");
              this.goApplyPageUrl = code;
            } else {
              this.$message.error(code);
            }
            this.loading = false;
          } catch (error) {
            resetLoading();
            this.$message.error(error);
          }
        }
      });
    } catch (error) {
      console.log(error);
      resetLoading();
    }
  }
  /**
   * 获取提现明细
   */
  async queryHistory() {
    const { orgCode } = this.userInfo;
    const { currentPage, pageSize } = this;
    const { serialNumber, date } = this.searchForm;
    let pageInput = {
      pageNum: currentPage,
      pageSize: pageSize
    };
    let input = {};

    serialNumber && (input["channelOrderNo"] = serialNumber);
    if (date && date.length > 0) {
      input["startTime"] = date[0];
      input["endTime"] = date[1];
    }
    orgCode && (input["orgCode"] = orgCode);
    const params = {
      input,
      pageInput
    };
    try {
      this.tableLoading = true;
      const { list = [], total } = await this.queryWithdrawFlow(params);
      const singleCardNo = this.getObjVal("cardNo");
      this.total = total;
      const data = list || [];
      this.flowDataList = data.map(item => ({ cardNo: singleCardNo, ...item }));
      this.tableLoading = false;
    } catch (error) {
      this.tableLoading = false;
      console.log(error);
    }
  }
  /**
   * 获取交易明细
   */
  async queryTradeHistory() {
    // const { orgCode } = this.userInfo;
    const { serialNumber, date } = this.searchForm;
    const { currentPage, pageSize } = this;
    let pageInput = {
      pageNum: currentPage,
      pageSize: pageSize
    };
    let input = {};
    serialNumber && (input["serialNumber"] = serialNumber);
    if (date && date.length > 0) {
      input["transactionStartTime"] = date[0];
      input["transactionEndTime"] = date[1];
    }
    this.searchFormParams = input;
    try {
      this.tableLoading = true;
      const { list = [], total } = await this.queryWtOrderFlowPage({
        input,
        pageInput
      });
      this.total = total;
      this.tradeDataList = list || [];
      this.tableLoading = false;
    } catch (error) {
      this.tableLoading = false;
      console.log(error);
    }
  }

  async submitFn() {
    let $form = this.$refs.mainForm as any;
    $form.validate(async val => {
      if (val) {
        // if (!Number(this.form.widthdrawMoney)) {
        //   this.$message.warning("提现金额不可为0");
        //   return;
        // }
        this.showConfirmSubmit = true;
      }
    });
  }
  confirmWithdrawSubmit = debounce(() => {
    this.onConfirmWithdrawSubmit();
  }, 500);
  async onConfirmWithdrawSubmit() {
    const { CHANNELTYPE, PAYMENT_TYPE, getObjVal } = this;
    const { orgCode } = this.userInfo;
    const orderUid = String(new Date().getTime());
    const tenantOrderTime = getNowYYYYMMDDhhmmss();
    const payAmount = this.form.widthdrawMoney;
    const subNo = getObjVal("memberNo");
    const subName = getObjVal("memberName");
    const input = {
      channelType: CHANNELTYPE, // 支付渠道
      paymentType: PAYMENT_TYPE, // 支付方式
      tenantOrderNo: orderUid, // 租户订单号
      payAmount, // 订单金额
      orderDesc: "K1-虚拟账号提现", // 订单描述
      tenantOrderTime, // 租户订单时间
      storeCode: orgCode,
      extendParams: `{"subMerchantNo": "${subNo}","subMerchantName":"${subName}"}`, // 扩展参数
      currency: this.CURRENCY //
    };

    const initData = () => {
      this.resetForm();
      // 这里刷新的东西还是蛮多的。。。。有点乱，报错也要刷新？
      this.getData(false);
      this.getMyBonusAccountApi();
      this.getDataList();
    };
    try {
      const {
        data: {
          api: { payReturnCode, payReturnDesc }
        }
      } = await this.withdrawApply({
        input
      });
      /** 
        payReturnCode #支付中心返回状态码
        payReturnDesc #支付中心返回信息
        10151111 提现成功code
        10151003 提现失败code
       */
      console.log(payReturnCode, payReturnDesc, "payReturnDesc");
      if (payReturnCode === "10151111") {
        this.$message.success("提现申请发起成功");
        this.showConfirmSubmit = false;
      } else {
        this.$message.error(payReturnDesc || "提现失败");
        // 特殊处理
        this.showConfirmSubmit = false;
      }
      initData();
    } catch (error) {
      this.showConfirmSubmit = false;
      initData();
      console.log(error);
    }
  }

  async exportExcelFn() {
    return await this.exportWtOrderFlow({ input: this.searchFormParams });
  }
  resetForm() {
    let $form: any = this.$refs.mainForm;
    $form && $form.resetFields();
  }
  resetDialogForm() {
    this.$nextTick(() => {
      let $form: any = this.$refs.dialogFormRef;
      $form && $form.resetFields();
    });
  }
  resetSearchForm() {
    this.searchForm.serialNumber = "";
    if (this.activeName === "1") {
      this.searchForm.date = [];
    }
    if (this.activeName === "0") {
      this.$nextTick(() => {
        (this.$refs.wtDatePickerRef as any).setDefaultValue();
      });
    }
  }
  getObjVal(prop) {
    return this.form && this.form[prop];
  }
  getDataList() {
    if (this.activeName === "1") {
      this.queryHistory();
    } else {
      this.queryTradeHistory();
    }
  }
  handlePageChange(page) {
    this.currentPage = page;
    this.getDataList();
  }
  handleTabClick(val) {
    this.activeName = val;
    this.resetSearchForm();
    this.currentPage = 1;
    this.getDataList();
    this.getData();
  }
  validIntNum = (rule, value, callback) => {
    const isValid = moneyRegexp.test(String(value)) && parseInt(value);
    const availableAmt = this.getObjVal("availableAmt");
    if (isValid) {
      if (Number(value) > Number(availableAmt)) {
        callback(new Error("可提现金额不足"));
      } else {
        callback();
      }
    } else {
      if (Number(value) === 0) {
        callback(new Error("提现金额不可为0"));
      } else {
        callback(new Error("格式错误"));
      }
    }
  };
}
